<template>
  <div>
    <el-dialog
        :visible.sync="searchPeopleDialogVisible"
        width="800px">
        <div  style="margin-bottom: 10px;">
            <h2>{{ searchPeopleDialogData.title }}</h2>
        </div>
        <el-form ref="form" :model="searchForm"  :rules="rules" label-width="80px">
            <el-form-item label="人物照片" prop="peoplePic">
                <imageUpload 
                v-if="searchPeopleDialogVisible"
                :limit="3" 
                @fileList="handleFileList"
                :fileType="['png','jpeg', 'jpg']"
                :fileSize="4"
                :isShowTip="true"
                :isShowCustomTip="true"
                :customTip="customTip"
                >
                </imageUpload>
                {{searchForm.peoplePic.length}}/3
            </el-form-item>
            <el-form-item label="地区">
                <div class="form-length-limit">
                    <el-select style="width: 100%;" clearable v-model="searchForm.region" placeholder="请选择">
                        <el-option
                        v-for="item in regionOptions"
                        :key="item.value"
                        
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </el-form-item>
            <el-form-item label="姓名">
                <div class="form-length-limit">
                    <el-input v-model="searchForm.name" placeholder="请输入姓名"></el-input>
                </div>
            </el-form-item>
            <el-form-item label="分类">
                <div class="form-length-limit">
                    <el-select style="width: 100%;" clearable v-model="searchForm.classify" placeholder="请选择">
                        <el-option
                        v-for="item in categoryOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </el-form-item>
            <el-form-item label="入库时间">
                <el-date-picker
                    v-model="searchForm.timeInterval"
                    type="datetimerange"
                    style="margin-right: 20px;"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="timestamp"
                    range-separator="至"
                    start-placeholder="开始日期"
                    :picker-options="pickerOptions"
                    end-placeholder="结束日期"
                    align="right">
                </el-date-picker>
                <el-checkbox v-model="timeIntervalChecked" @change="changeTimeInterval">全部</el-checkbox>
            </el-form-item>

        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="searchPeopleDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="confirmSearch()">确 定</el-button>
        </span>
    </el-dialog>
    <el-dialog :visible.sync="imgDialogVisible"
    :show-close="false">
        <div  style="margin-bottom: 10px;display: flex;justify-content: space-between;align-items: center;">
            <h2>图片预览</h2>
            <el-button icon="el-icon-close" circle type="danger" @click="imgDialogVisible = false"></el-button>
        </div>
        <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
// import { downLoadFile } from "@/plugins/util.js"
// import { uploadPic } from "@/api/file"
// import BASEURL from "@/config/index"
import  imageUpload  from '@/components/imageUpload/index.vue';


export default {
    name: 'searchPeopleDialog',
    components:{
        imageUpload
    },
    
    data() {
        return {
            timeIntervalChecked:false,
            searchPeopleDialogData:{},
            searchPeopleDialogVisible: false,
            dialogImageUrl: '',
            imgDialogVisible: false,
            disabled: false,
            customTip: '请上传正面且清晰的单人照片进行比对，',
            rules: {
                peoplePic: [{ required: true, message: '请上传人物照片', trigger: 'change' }],
            },
            searchForm: {
                peoplePic:[],
                region:'',
                name:'',
                classify:'',
                timeInterval:[],
            },
            regionOptions: [
                {label:'全部',value:''},
                {label:'国外',value:'国外'},
                {label:'国内',value:'国内'},
                {label:'本地',value:'本地'},
                
            ],
            categoryOptions: [
                {label:'全部',value:''},
                {label:'政治',value:'政治'},
                {label:'商业',value:'商业'},
                {label:'娱乐',value:'娱乐'},
                {label:'公众',value:'公众'},
            ],
            pickerOptions:{
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },

        }
    },
    methods: {
        changeTimeInterval(val) {
            if (val) {
                this.searchForm.timeInterval = []
            } else {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                console.log(start.getTime(), end.getTime());
                    
                this.searchForm.timeInterval=[start.getTime(),end.getTime()]
            }
            // console.log(val);
        },
        confirmSearch() {
            console.log(this.searchForm.peoplePic);
            if (this.searchForm.peoplePic.length == 0) {
                this.$message({
                    type: 'warning',
                    message: '请上传人物照片',
                });
                return
            }
            let picIdsList = []
            this.searchForm.peoplePic.forEach((ele) => {
                picIdsList.push(ele.id)
            })
            let params = {
                // timeInterval: [],
                fileIds: '',
                type:this.searchPeopleDialogData.type
            }
            
            params.fileIds = picIdsList.join(',')
            params.peoplePic=this.searchForm.peoplePic
            
            if (this.searchForm.classify) params.classify = this.searchForm.classify
            if (this.searchForm.region) params.region = this.searchForm.region
            if (this.searchForm.name) params.name = this.searchForm.name
            if (this.searchForm.timeInterval.length > 0) {
                params.timeInterval = []
                this.searchForm.timeInterval.forEach((ele) => {
                    ele = parseInt(ele / 1000)
                    console.log(ele);
                    params.timeInterval.push(ele)
                })
                // params.timeInterval = this.searchForm.timeInterval
            }
            // console.log(params);
            let query = {
                fileIds:params.fileIds
            }
            console.log(params);
            sessionStorage.setItem('MEDIA_PARAMS',JSON.stringify(params));
            let routeUrl = this.$router.resolve({
                path: "/mediaResult",
                query
            });
            this.searchPeopleDialogVisible = false

            window.open(routeUrl.href, '_blank');
            // this.$router.push({
            //     path: '/mediaResult',
            //     query
            // })

            
        },
        handleFileList(val) {
            console.log(val);
            this.searchForm.peoplePic = val;
        },
        async acceptParams(params) {
            this.searchPeopleDialogData = params;
            this.searchPeopleDialogVisible = true;
        },
        handleRemove(file) {
            console.log(file);
        },
        beforeAvatarUpload(file) {
            console.log(file);
            const isJPG = file.type === 'image/jpeg';
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
            this.$message.error('上传头像图片只能是 JPG 格式!');
            }
            if (!isLt2M) {
            this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
        },
        beforeUpload(file) {
            const isLt5M = file.size / 1024 / 1024 < 5;
            const type = ["image/jpeg", "image/png", "image/jpeg"];
            let isJPG = type.indexOf(file.raw.type) > -1;

            if (!isLt5M) {
                this.$message.error("上传图片大小不能超过 5MB!");
                return false;
            }

            if (isJPG) {
                if (file.raw.name.substring(file.raw.name.length - 4) === "jpeg") {
                isJPG = false;
                }
            }
            if (!isJPG) {
                this.$message.error("上传图片格式只能为jpg，jpeg和png！");
                return false;
            }
        },
        async onBgtu(file, fileList) {
            console.log(file, fileList);
            const isLt5M = file.size / 1024 / 1024 < 5;
            const type = ["image/jpeg", "image/png", "image/jpeg"];
            let isJPG = type.indexOf(file.raw.type) > -1;

            if (!isLt5M) {
                this.$message.error("上传图片大小不能超过 5MB!");
                return false;
            }

            if (isJPG) {
                if (file.raw.name.substring(file.raw.name.length - 4) === "jpeg") {
                isJPG = false;
                }
            }
            if (!isJPG) {
                this.$message.error("上传图片格式只能为jpg，jpeg和png！");
                return false;
            }
            // var paramData = new FormData();
            // paramData.append("file", file.raw);
            // let { status, data, message } = await uploadPic(paramData);
            // if (status) {
            //     console.log(data);
            //     // this.searchForm.peoplePic = data;
            //     let file = {
            //         name: file.name,
            //         url: data.url,
            //     }
            //     this.searchForm.peoplePic.push(file);
            // } else {
            //     this.$message.error(message);
            // }
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.imgDialogVisible = true;
        },

    },
    created() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        console.log(start.getTime(), end.getTime());
              
        this.searchForm.timeInterval=[start.getTime(),end.getTime()]
    },
}
</script>

<style lang="scss" scoped>
.form-length-limit{
    width: 400px;
}
</style>